import * as React from 'react';
import * as debounce from 'lodash.debounce';

import CategoriesFilter from 'src/components/CategoriesFilter';
import ProductCatalogBox from 'src/components/ProductCatalogBox';
import {categoryUrl } from 'src/utils/navigation';
import './Categories.scss';
import SubcategoryModel from 'src/model/subcategory.model';
import SubcategoryFilter from 'src/model/subcategoryFilter.model';
import SubcategoryBrandFilter from 'src/model/subcategoryBrandFilter.model';
import ProductModel from 'src/model/product.model';
import listService from 'src/services/lists/ListsService';
import CustomPaginator from 'src/components/common/CustomPaginator';
// import ProductModel from 'src/model/product.model';

interface IFavoriteItem {
  key: string;
  value: number | string;
}
interface IState {
  contentScroll: boolean;
  favoriteArr: IFavoriteItem[];
  isFavoriteLoading: boolean;
  favoriteLoadingItem: string;
};

class Categories extends React.Component<any, any> {
  constructor(props: any) {
    super(props);

    this.state = {
      contentScroll: true,
      selectionTypeFilter: '',
      favoriteArr: [],
      isFavoriteLoading:false
    };
  }

  private handlePageChange = (event: any) => {
    const debouncedService = debounce(() => {
      if (this.props.activeFilters && this.props.activeFilters.length) {
        this.props.getFilteredProducts(
          this.props.match.params.subcategoryId.toString(),
          this.props.activeFilters,
          this.state.selectionTypeFilter,
          event - 1,
          this.props.paginator.pageSize
        );
      } else {
        this.props.getProductsBySubCategory(
          this.props.match.params.subcategoryId,
          this.props.activeAccount,
          event - 1,
          this.props.paginator.pageSize
        );
      }
      window.scrollTo(0, 0);
    }, 1000);
    debouncedService();
  };

  private handlePageSizeChange = (event: any) => {
    const debouncedService = debounce(() => {
      if (this.props.activeFilters && this.props.activeFilters.length) {
        this.props.getFilteredProducts(
          this.props.match.params.subcategoryId.toString(),
          this.props.activeFilters,
          this.state.selectionTypeFilter,
          0,
          event
        );
      } else {
        this.props.getProductsBySubCategory(
          this.props.match.params.subcategoryId,
          this.props.activeAccount,
          0,
          event
        );
      }
      window.scrollTo(0, 0);
    }, 1000);
    debouncedService();
  };

  private onRouteChanged() {
    const empty: any = [];
    this.props.getCategories(this.props.match.params.categoryId);
    this.props.setActiveFilters(empty);
    this.props.getSubcategoriesFilters(this.props.match.params.subcategoryId);
    this.props.getSubcategoriesBrands(this.props.match.params.subcategoryId);
    this.props.getProductsBySubCategory(
      this.props.match.params.subcategoryId,
      this.props.activeAccount
    );
    // if (this.props.activeFilters && this.props.activeFilters.length) {
    //   debugger;
    //   this.props.getFilteredProducts(
    //     this.props.match.params.subcategoryId.toString(),
    //     this.props.activeFilters
    //   );
    // } else {
    //   this.props.getProductsBySubCategory(
    //     this.props.match.params.subcategoryId,
    //     this.props.activeAccount
    //   );
    // }
  }

  private getSelectedSubcategory() {
    const found = this.props.subcategories.find(
      (sub: SubcategoryModel) =>
        sub.id === parseInt(this.props.match.params.subcategoryId, 10)
    );
    return found;
  }

  private getSelectedFilter() {
    const activeFilters = this.props.activeFilters.map((f:any) => f.name);
    const matchedFilter = this.props.filters.filter((f:any) => activeFilters.includes(f.name));
    return matchedFilter;
  }

  private handleSamePageClick(
  e: React.MouseEvent<HTMLAnchorElement>,
  href: string,
  categoryId?: number,
  subcategoryId?: number
): void {
  const current = window.location.pathname + window.location.search + window.location.hash;
  const u = new URL(href, window.location.origin);
  const target = u.pathname + u.search + u.hash;

  // Same URL → force a hard refresh
  if (current === target) {
    e.preventDefault();
    window.location.reload();
    return;
  }

  // Different URL → navigate programmatically (or let the <a> do it)
  if (categoryId != null && subcategoryId != null) {
    e.preventDefault(); // prevent default if you programmatically navigate
    categoryUrl(categoryId, subcategoryId); // your app's navigation
    return;
  }

  // else: do nothing → allow the <a href> to navigate normally
}


  private renderTitle() {
    const selectedPartType = this.getSelectedFilter();   
    const subcategory = this.getSelectedSubcategory();
    if (!subcategory) {
      return <div />;
    }
    return (
      <div className="rp-categories-page--title roboto">
        {/*<span className='span-blue'>
        {(window.location.pathname === "/ca/fr/" || window.location.pathname === "/ca/fr" || window.location.pathname.includes("/ca/fr/")) && subcategory.category.frName!== null 
            ?subcategory.category.frName
            :subcategory.category.name}
        </span> 
        <i className="rpds rpds-chevron-right" /> 
        */}
        <span className='span-green'>
          <a style={{ textDecoration: "none", color: "#0d872e" }} href={categoryUrl(subcategory.category.id, subcategory.id)} onClick={(e) =>
    this.handleSamePageClick(e, categoryUrl(subcategory.category.id, subcategory.id), subcategory.category.id, subcategory.id)
  }>
          {(window.location.pathname === "/ca/fr/" || window.location.pathname === "/ca/fr" || window.location.pathname.includes("/ca/fr/")) && subcategory.frName!== null 
              ?subcategory.frName
              :subcategory.name}
          </a>
        </span>
        
        {selectedPartType.length !==0 && selectedPartType.map((partType: any, index: any) => (
          <>
            <i className="rpds rpds-chevron-right" />
            <span className='span-green'>
              {(window.location.pathname === "/ca/fr/" || window.location.pathname === "/ca/fr" || window.location.pathname.includes("/ca/fr/")) && partType.frName !== null
                ? partType.frName
                : partType.name}
            </span>
          </>
        ))}
        
        <div className="categories-paginator-container">
          <CustomPaginator
            activePage={
              this.props.paginator.pageNumber
                ? this.props.paginator.pageNumber + 1
                : 1
            }
            totalPages={this.props.paginator.totalPages}
            itemsPerPage={this.props.paginator.pageSize}
            onPageChanged={this.handlePageChange}
            totalItems={
              this.props.paginator.totalPages * this.props.paginator.pageSize
            }
            showPageInfo={true}
            showPageRangeChange={false}
            currentPageSize={this.props.paginator.pageSize}
            onPageSizeChange={this.handlePageSizeChange}
          />
        </div>
      </div>
    );
  }

  private handleContentScroll = (shouldScroll: boolean) => {
    this.setState({ contentScroll: shouldScroll });
  };

  private handleFilters = (
    newFilter: SubcategoryFilter,
    action: 'add' | 'remove',selectiontype:any
  ) => {
    this.setState({ selectionTypeFilter: selectiontype });
    if (action === 'add' && selectiontype === 'filter') {
      // this.props.setActiveFilters([...this.props.activeFilters, newFilter]);
      this.props.setActiveFilters([newFilter],selectiontype);
    } else if (action === 'add' && selectiontype === 'brand') {
       this.props.setActiveFilters([...this.props.activeFilters, newFilter],selectiontype);
    } else if (action === 'add' && selectiontype === 'coating') {
      this.props.setActiveFilters([...this.props.activeFilters, newFilter],selectiontype);      
    }  else if (action === 'add' && selectiontype === 'voltage') {
    this.props.setActiveFilters([...this.props.activeFilters, newFilter],selectiontype);      
    }   else if (action === 'add' && selectiontype === 'diameter') {
      this.props.setActiveFilters([...this.props.activeFilters, newFilter],selectiontype);      
    } else if (action === 'add' && selectiontype === 'length') {
      this.props.setActiveFilters([...this.props.activeFilters, newFilter],selectiontype);      
    }  else if (action === 'add' && selectiontype === 'weight') {
      this.props.setActiveFilters([...this.props.activeFilters, newFilter],selectiontype);      
    } else {
      const newFilters = this.props.activeFilters.filter(
        (filter: SubcategoryFilter) => filter.id !== newFilter.id
      );
      // console.log('action', newFilters);
      // console.log('action', newFilters.length);
      this.props.setActiveFilters([...newFilters],selectiontype);
      // console.log(newFilters.length)
      if (newFilters.length === 0) {
        this.props.getProductsBySubCategory(
          this.props.match.params.subcategoryId,
          this.props.activeAccount
        );
      }
    }
  };
  

  private sortProductsWithImages = (productArray: ProductModel[]) => {
    if (productArray.length !== 0) {
      // Sort products to show the ones with images first
      return productArray.sort((a: any, b: any) => {
        if (a.imageUrls !== null && a.imageUrls.length) {
          return 0;
        }
        if (b.imageUrls !== null && b.imageUrls.length) {
          return 1;
        }
        return 0;
      });
    } else {
      return productArray;
    }
  };

  private getDataSource = () => {
    if (this.props.activeFilters.length === 0) {
      const { products } = this.props;
      return this.sortProductsWithImages(products);
    } else {
      return this.sortProductsWithImages(this.props.filteredProducts);
    }
  };

  private addToFavorites = (key: string, value: number) => {
    const newItem: IFavoriteItem = { key, value };
    this.setState((prevState:any) => ({
      favoriteArr: [...prevState.favoriteArr, newItem]
    }));
  };

  private removeFromFavorites = (keyToRemove: string, valueToRemove: number) => {
    this.setState((prevState:any) => ({
      favoriteArr: prevState.favoriteArr.filter(
        (item:any) => !(item.key === keyToRemove && item.value === valueToRemove)
      )
    }));
  };

  private handleToggleFavorite = (
    name: string,
    mfc: string,
    favorite: boolean,
    favoriteId: number
  ) => {
    this.setState({ isFavoriteLoading: true });
    this.setState({ favoriteLoadingItem: name });    
    if (favorite || this.state.favoriteArr.includes(name)) {
      listService.deleteItem(favoriteId).then(res => {
        this.removeFromFavorites(name,favoriteId);   
        this.addToFavorites(name,1); 
        this.setState({ isFavoriteLoading: false }); 
      });
    } else {
      listService.addItem('favorites', name, mfc).then(res => {
        this.removeFromFavorites(name,1);         
        this.addToFavorites(name,res.listItemNumber);
        this.setState({ isFavoriteLoading: false }); 
      });
    }
  };

  public componentDidMount() {
    this.props.getCategories(this.props.match.params.categoryId);

    this.props.getSubcategoriesFilters(this.props.match.params.subcategoryId);
    this.props.getSubcategoriesBrands(this.props.match.params.subcategoryId);
    if (this.props.activeFilters && this.props.activeFilters.length) {
      this.props.getFilteredProducts(
        this.props.match.params.subcategoryId.toString(),
        this.props.activeFilters,
        this.state.selectionTypeFilter
      );
    } else {
      this.props.getProductsBySubCategory(
        this.props.match.params.subcategoryId,
        this.props.activeAccount
      );
    }
  }

  public componentDidUpdate(prevProps: any) {
    if (this.props.location !== prevProps.location) {
      this.onRouteChanged();
    }

    if (
      prevProps.activeFilters !== this.props.activeFilters &&
      this.props.activeFilters.length
    ) {
      this.props.getFilteredProducts(
        this.props.match.params.subcategoryId.toString(),
        this.props.activeFilters,
        this.state.selectionTypeFilter
      );
    }
  }

  public render() {
    const { t } = this.props;
    const contentScroll = this.state.contentScroll ? 'scroll' : 'no-scroll';

    return (
      <section id="rp-categories-page">
        <div className="rp-categories-page--filters">
          <CategoriesFilter
            selectedSubcategory={this.getSelectedSubcategory()}
            handleScroll={this.handleContentScroll}
            filtersPending={this.props.getSubcategoriesFilterIsPending}
            filters={this.props.filters}
            brands={this.props.brands}
            brandFilters={this.props.brandFilters}
            activeFilters={this.props.activeFilters}
            activeBrands={this.props.activeBrands}
            setFilters={this.handleFilters}
            clearFilters={this.props.setActiveFilters}
            getFilteredProducts={this.props.getFilteredProducts}
            isLoadingSubcategories={this.props.getSubcategoriesIsPending}
            products={this.getDataSource()}
          />
        </div>
        <div className={`rp-categories-page--content ${contentScroll}`}>
          {this.renderTitle()}
          <ProductCatalogBox
            subcategory={this.getSelectedSubcategory()}
            products={this.getDataSource()}
            loading={this.props.getProductsIsPending}
            emptyMessage={t('common.emptySubcategory')}
            handlePageChange={this.handlePageChange}
            paginator={this.props.paginator}
            handleToggleFavorite={this.handleToggleFavorite}
            handlepageSizeChange={this.handlePageSizeChange}
            favoritesArr = {this.state.favoriteArr}
            isFavoriteLoading = {this.state.isFavoriteLoading}
            favoriteLoadingItem = {this.state.favoriteLoadingItem}            
          />
        </div>
      </section>
    );
  }
}

export default Categories;
